import React from 'react';
import classNames from 'classnames';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import LoadingPlaceholder from '@lib/components/LoadingPlaceholder/LoadingPlaceholder';
import styles from './SectorMapPopupContent.module.scss';

export default function SectorMapPopupContentLoading() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.sectorNameWrap}>
        <LoadingPlaceholder height={21} widthPercent={80} />
      </div>
      <div
        className={classNames(
          entityViewStyles.infoItem,
          entityViewStyles.block,
        )}
      >
        <LoadingPlaceholder height={32} />
      </div>
    </div>
  );
}
